<template>
	<div>
		<el-card>
			<el-form :inline="true" ref="selectForm" :model="formInline" class="demo-form-inline" style="" size="mini">
				<el-form-item label="门店名称">
					<el-input v-model="formInline.store_name" placeholder="可模糊搜索" clearable></el-input>
				</el-form-item>
				<el-form-item label="负责人">
					<el-input v-model="formInline.store_man" placeholder="可模糊搜索" clearable></el-input>
				</el-form-item>
				<el-form-item label="负责人电话">
					<el-input v-model="formInline.store_tel" placeholder="可模糊搜索" clearable></el-input>
				</el-form-item>
			
				<el-form-item>
					<el-button type="primary" @click="getData()">查询</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<el-card style="margin-top: 10px;">
			<el-table :data="data.stores"  style="width: 100%;text-align: center;"   size="mini">
				<el-table-column align="center" header-align="center"  label="编号" width="100">
					<template slot-scope="scope">
						{{scope.$index + 1}}
					</template>
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="store_name" label="门店名称">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="store_man" label="负责人">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="store_tel" label="负责人电话">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="store_address" label="门店地址">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="alipay_login_user" label="支付宝账号">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="store_addDate" label="申请时间">
					<template slot-scope="scope">
						{{timeFormat(scope.row.store_addDate,'yyyy-mm-dd hh:MM:ss')}}
						<!-- <el-button size="mini" type="danger" @click="deleteStore(scope.$index, scope.row)">取消认证</el-button> -->
					</template>
				</el-table-column>
				<el-table-column align="center" header-align="center" label="查看" width="150">
					<template slot-scope="scope">
						<div style="color:#32D1B9;">
							<el-button type="primary" size="mini" icon="el-icon-search" @click="toInfo(scope.row)">查看</el-button>
						</div>
						<!-- <el-button size="mini" type="danger" @click="deleteStore(scope.$index, scope.row)">取消认证</el-button> -->
					</template>
				</el-table-column>
				<el-table-column align="center" header-align="center" label="认证" width="150">
					<template slot-scope="scope">
						<el-button size="mini"  type="success" @click="authStore(scope.$index, scope.row)">认证</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="display: flex;justify-content: flex-end; ">
			    <el-pagination
			      @size-change="handleSizeChange"
			      @current-change="handleCurrentChange"
			      :current-page="formInline.page"
			      :page-sizes="[20, 50, 100, 200]"
			      :page-size="formInline.limit"
			      layout="total, sizes, prev, pager, next, jumper"
			      :total="data.storeListCount">
			    </el-pagination>
			  </div>
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				formInline: {
					store_name: '',
					store_man: '',
					store_tel: '',
					store_state:0,
					page: 1,
					limit: 10
				},
				data: {}
			}
		},
		mounted() {
			this.getData();
		},
		methods: {
			toInfo(store){
				this.$router.push({path:'/storeInfo',query:{store_id:store.store_id}});
			},
			handleSizeChange(e){
				this.formInline.limit=e;
				this.getData();
			},
			handleCurrentChange(e){
				this.formInline.page=e;
				this.getData();
			},
			authStore(index, row) {
				var that = this;
				row.store_state=1;
				that.$axios.post('zuche/admin/authStore', row).then(function(res) {
					if (res.data.success) {
						that.getData();
					} else {
						that.$message.error(res.data.message);
					}
				});
			},
			getData() {
				var that = this;
				this.$axios.post('zuche/admin/getStoreList', this.formInline).then(function(res) {
					console.log(res);
					if (res.data.success) {
						that.data = res.data.result;
						
					} else {
						that.$message.error(res.data.message);
					}
				});
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/storeListUnAuth.vue